import React from 'react';
import { Button } from '@/components/ui/button';

const InterestedSection: React.FC = () => {
  const scrollToCtaSection = () => {
    const ctaSection = document.getElementById('cta-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="section-padding bg-white">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto animate-on-scroll">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Interested In Working With Us?
          </h2>
          <Button 
            onClick={scrollToCtaSection}
            size="lg"
            className="bg-primary hover:bg-primary-700"
          >
            Get Early Access
          </Button>
        </div>
      </div>
    </section>
  );
};

export default InterestedSection;
